import styled from 'styled-components'
import { StackChildren, Stack, Text, Spacing } from '@doordash/design-language'

export const HeaderTitle = styled(Text).attrs<{}>({
  tag: 'h1',
  styles: Text.Styles.Bold32,
})`
  width: 240px;
`

export const TitleContainer = styled(Stack).attrs<{}>({
  size: Stack.Sizes.Large,
})`
  display: flex;
  justify-content: center;
`

export const WaitlistContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  padding: ${Spacing.Large}px;
`

export const InfoContainer = styled(StackChildren)`
  background-color: #F7F7F7;
  border-radius: ${Spacing.XxSmall}px;
  padding: ${Spacing.Medium}px;
  max-width: 500px;
  min-height: 220px;
`